<script setup lang="ts">
import { percentFormat } from '../helpers/percentFormat';

const props = defineProps<{
  percent: number;
  fractionDigits?: number;
}>();
</script>

<template>
  <span>
    {{ percentFormat(props.percent, fractionDigits) }}
  </span>
</template>
